import { memo } from 'react'
import { useIntercomManager } from 'src/hooks/useIntercomManager'

export const IntercomManager = memo(() => {
  useIntercomManager()

  return null
})
